var exports = {
  "zr": "xa15a2ab7--67f667--root",
  "Qs": "xa15a2ab7--67f667--content",
  "r9": "xa15a2ab7--67f667--disabled",
  "kA": "xa15a2ab7--67f667--icon-container",
  "e": "xa15a2ab7--67f667--text-container",
  "_n": "xa15a2ab7--67f667--text-container_placeholder",
};

module.exports = exports;
